import { Column, Entity, OneToMany, PrimaryGeneratedColumn, VersionColumn } from "typeorm";
import { PostEntity } from "./post.entity";

@Entity('post_category')
export class PostCategoryEntity {
  
    @PrimaryGeneratedColumn("increment",{name:'id'})
    Id:number;
    @Column("varchar",{
      nullable: false,
      length:500,
      name:"category"
    })
    postcategory:string;
    @Column("boolean",{
      nullable:false,
      default:true,               
      name:"status"
    })
    status:boolean;   
    @VersionColumn({
        default:1,
        name: "version_flag"
    })
    versionFlag: number;
    @Column("varchar",{
      nullable: false,
      length:100,
      name:"Location"
    })
    Location:string;
    @OneToMany(() => PostEntity, (post: PostEntity) => post.postcategory)
    post: PostEntity;
   
  }